import { updateKeyInStore } from 'App';
import { PastFillingsStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof PastFillingsStateValues>[] = [
  {
    name: 'lastFiledFederalReturnCopy',
    label: 'Please upload a copy of last filed Federal return',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.past_fillings.values.didWePrepareFederalTaxReturn',
    predicate: (value) => value === 'no',
  },
  {
    type: 'upload',
    name: 'lastFiledStateReturnCopy',
    label: 'Please upload a copy of the last filed State tax return(s)',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.past_fillings.values.didWePrepareStateTaxReturn',
    predicate: (value) => value === 'no',
  },
  {
    type: 'upload',
    name: 'IRSLetterCopies',
    label: 'Upload copies of IRS letters',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.past_fillings.values.audited',
    predicate: (value) => value === 'yes',
  },
];
